<div class="container-fluid">
  <page-header-breadcrumb
    [pageTitleValue]="pageTitle"
    [pageLinkValue]="pageLink"
    [currentPageValue]="
      editMode ? 'Edit Home visit fees' : 'Add Home visit fees'
    "
  ></page-header-breadcrumb>
  <div class="card mb-4">
    <div class="card-body">
      <form [formGroup]="addFeesForm" (ngSubmit)="onAddFeesSubmit()">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-control-label" for="fees-area">
                Choose Area
              </label>
              <select
                formControlName="feesArea"
                class="form-control"
                id="fees-area"
                [disabled]="editMode"
              >
                <option *ngFor="let area of areasArray" [value]="area.id">
                  {{ area.name }}
                </option>
              </select>
              <div
                *ngIf="
                  (isSubmited || addFeesForm.controls.feesArea.dirty) &&
                  addFeesForm.controls.feesArea.errors
                "
                class="input-errors"
              >
                <p *ngIf="addFeesForm.controls.feesArea.errors.required">
                  This field is required!
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-control-label" for="fees-value"> Fees </label>
              <input
                class="form-control"
                id="fees-value"
                formControlName="feesValue"
                placeholder="Fees"
                type="number"
                min="0"
              />
              <div
              *ngIf="
                (isSubmited || addFeesForm.controls.feesValue.dirty) &&
                addFeesForm.controls.feesValue.errors
              "
              class="input-errors"
            >
              <p *ngIf="addFeesForm.controls.feesValue.errors.required">
                This field is required!
              </p>
            </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col btns-block">
            <button
              class="btn btn-primary"
              type="submit"
              [disabled]="addFeesForm.invalid"
            >
              {{ editMode ? "Edit" : "Save" }}
            </button>
            <button
              class="btn btn-outline-danger"
              type="button"
              [routerLink]="pageLink"
            >
              Cancel
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
